import { Outlet } from "react-router-dom";
import useLicenseValidator from "../../hooks/useLicenseValidator";
import { NeedLicense } from "../../components/need-license/need-license";

const LicenseVerify = ({ base, setBase }) => {
  const isProd = process.env.NEXT_PUBLIC_NODE_ENV === "prod";

  let innerContent = <Outlet />;
  if (isProd) {
    const licenseData = useLicenseValidator(base?.org, base?.user);

    if (licenseData?.valid === false) {
      innerContent = (
        <NeedLicense
          org={base?.org}
          appState={base?.app}
          user={base?.user}
          team={base?.team}
          licenseData={licenseData}
          setBase={setBase}
        />
      );
    }
  }
  
  return innerContent;
};

export default LicenseVerify;
